// Path: ./src/hooks/usePermissions.ts
import { useState, useEffect, useCallback } from "react";
import { adminApiService } from "../utils/api";
import { GfPermission } from "@swagger/typescript-fetch-goflyer";

export const usePermissions = () => {
  const [permissionsList, setPermissionsList] = useState<GfPermission[]>(); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) maybe we should do the mapping here to create label

  const fetchPermissions = useCallback(async () => {
    try {
      const permissions =
        await adminApiService.getManyBaseGfPermissionAdminControllerGfPermission();

      setPermissionsList(permissions.data);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  }, []);

  useEffect(() => {
    fetchPermissions();
  }, []);

  return { permissionsList, fetchPermissions };
};
